<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-sm-flex align-items-center justify-content-between">
        <app-rp-breadcrumb [breadcrumbItems]="breadCrumbItems"></app-rp-breadcrumb>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <form [formGroup]="evMeterForm">
            <div class="row">
              <div class="col-lg-4">
                <div class="mb-3">
                  <label>Device Sr No <span class="required">*</span></label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="meterSerialNo"
                    placeholder="Enter Device Serial Number"
                  />
                  @if ((submitted || controls["meterSerialNo"].touched) && controls["meterSerialNo"].errors) {
                    <div class="invalid-feedback">
                      @if (controls["meterSerialNo"].errors["required"]) {
                        <div>{{ validations.meterSerialNo.required }}</div>
                      }
                      @if (controls["meterSerialNo"].errors["pattern"]) {
                        <div>{{ validations.meterSerialNo.isNotWiredPattern }}</div>
                      }
                      @if (controls["meterSerialNo"].errors["minlength"]) {
                        <div>{{ validations.meterSerialNo.minlength }}</div>
                      }
                      @if (controls["meterSerialNo"].errors["maxlength"]) {
                        <div>{{ validations.meterSerialNo.maxlength }}</div>
                      }
                    </div>
                  }
                </div>
              </div>

              <div class="col-lg-4">
                <div class="mb-3">
                  <label>Mac Address <span class="required">*</span></label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="macAddress"
                    placeholder="Enter Mac Address"
                  />
                  @if ((submitted || controls["macAddress"].touched) && controls["macAddress"].errors) {
                    <div class="invalid-feedback">
                      @if (controls["macAddress"].errors["required"]) {
                        <div>{{ validations.macAddress.required }}</div>
                      }
                      @if (controls["macAddress"].errors["pattern"]) {
                        <div>{{ validations.macAddress.pattern }}</div>
                      }
                      @if (controls["macAddress"].errors["minlength"] || controls["macAddress"].errors["maxlength"]) {
                        <div>{{ validations.macAddress.maxlength }}</div>
                      }
                    </div>
                  }
                </div>
              </div>

              <div class="col-lg-4">
                <div class="mb-3">
                  <label>Meter Status <span class="required">*</span></label>
                  <ng-select
                    [items]="statusItems"
                    formControlName="status"
                    [multiple]="false"
                    [placeholder]="'Select...'"
                  ></ng-select>
                  @if ((submitted || controls["status"].touched) && controls["status"].errors) {
                    <div class="invalid-feedback">
                      @if (controls["status"].errors["required"]) {
                        <div>{{ validations.meterStatus.required }}</div>
                      }
                    </div>
                  }
                </div>
              </div>

              <div class="col-lg-4">
                <div class="mb-3">
                  <label>Supplier Name <span class="required">*</span></label>
                  <ng-select
                    [items]="evSupplierItems"
                    bindLabel="name"
                    bindValue="id"
                    formControlName="supplierId"
                    [multiple]="false"
                    [placeholder]="'Select...'"
                    [clearable]="isClearable(evMeterForm.get('supplierId')?.value)"
                  ></ng-select>
                  @if ((submitted || controls["supplierId"].touched) && controls["supplierId"].errors) {
                    <div class="invalid-feedback">
                      @if (controls["supplierId"].errors["required"]) {
                        <div>{{ validations.supplierId.required }}</div>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          </form>

          <ul class="list-inline wizard d-flex justify-content-end mt-3">
            <li class="previous list-inline-item">
              <button class="btn btn-outline-primary" (click)="cancel()">
                Cancel
              </button>
            </li>
            @if (isEdit) {
              <li class="next list-inline-item">
                <button class="btn btn-primary" (click)="save('Update')">
                  Update
                </button>
              </li>
            } @else {
              <li class="next list-inline-item">
                <button class="btn btn-primary" (click)="save('Create')">
                  Save
                </button>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
